import { styles } from "@repo/helpers";

import style from "./style.module.scss";

interface Props {
	value: string | undefined;
}

export default function AgentSummaryPhoto(props: Props) {
	if (!props.value)
		return (
			<img
				className={styles("img-thumbnail", style.agentPhoto)}
				src={props.value ?? "/Images/default-profile-pic.jpg"}
				alt="Agent"
			/>
		);

	return <img className={styles("img-thumbnail", style.agentPhoto)} src={props.value} alt="Agent" />;
}
